import { cn } from '@/lib/utils'
import { Layout } from 'lucide-react'

const ProjectCardSkeleton = () => (
  <div
    className={cn(
      'cyber-card border-none p-0 overflow-hidden',
      'bg-gray-800/30 relative',
    )}
  >
    <div className="relative">
      <div className="w-full aspect-video rounded-lg flex items-center justify-center bg-gradient-to-br from-purple-500/5 to-cyan-400/5">
        <Layout className="w-8 h-8 text-cyan-400/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-800/0 via-cyan-500/10 to-gray-800/0 -translate-x-full animate-[shimmer_2s_infinite]" />
      </div>

      <div className="absolute top-3 right-3">
        <div className="w-20 h-7 rounded-full bg-gray-800/60 animate-pulse" />
      </div>
    </div>

    <div className="p-4">
      <div className="h-7 bg-gradient-to-r from-gray-800/60 to-gray-800/40 rounded mb-1 w-3/4 animate-pulse" />

      <div className="h-5 bg-gradient-to-r from-gray-800/60 to-gray-800/40 rounded mt-2 w-1/3 animate-pulse" />

      <div className="flex items-center gap-2 mt-3">
        <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-500/20 to-cyan-400/20 animate-pulse" />
        <div className="h-5 bg-gradient-to-r from-gray-800/60 to-gray-800/40 rounded w-1/4 animate-pulse" />
      </div>
    </div>
  </div>
)

type ProjectListSkeletonProps = {
  maxColumns?: number
  count?: number
  showSkeletonHeader?: boolean
}

export const ProjectListSkeleton = ({
  count = 6,
  maxColumns: columns = 3,
  showSkeletonHeader = true,
}: ProjectListSkeletonProps) => {
  return (
    <div className="rounded-2xl bg-gray-900/50 border border-gray-700/30 p-5 backdrop-blur-xl">
      {showSkeletonHeader && (
        <>
          <div className="mb-3">
            <div className="flex items-center gap-3 mb-1">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500/10 to-cyan-400/10 animate-pulse" />
              <div className="h-8 bg-gradient-to-r from-gray-800/60 to-gray-800/40 rounded w-48 animate-pulse" />
            </div>
            <div className="h-5 bg-gradient-to-r from-gray-800/60 to-gray-800/40 rounded ml-[44px] w-56 animate-pulse" />
          </div>

          <div className="flex gap-2 mb-4 ml-[44px]">
            <div className="w-24 h-8 rounded-full bg-gradient-to-br from-purple-500/10 to-cyan-400/10 animate-pulse" />
            <div className="w-24 h-8 rounded-full bg-gradient-to-br from-purple-500/10 to-cyan-400/10 animate-pulse" />
          </div>
        </>
      )}

      <div
        className={cn('grid grid-cols-1 gap-4', {
          'md:grid-cols-2': columns >= 2,
          'lg:grid-cols-3': columns >= 3,
        })}
      >
        {Array.from({ length: count }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <ProjectCardSkeleton key={i} />
        ))}
      </div>
    </div>
  )
}
